// extracted by css-extract-rspack-plugin
export default {"RefSelectorTabs":"RefSelector-module__RefSelectorTabs__JJgsKoc","RefSelectorTabLink":"RefSelector-module__RefSelectorTabLink__nkpkUVZ"};